import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, nextTick } from '@nuxtjs/composition-api';
import BravadoSelectV3 from '@/components/common/BravadoSelectV3/BravadoSelectV3.vue';
import BravadoTextInputV3 from '@/components/common/BravadoTextInputV3/BravadoTextInputV3.vue';
import type { SelectableOption } from '@/components/partials/public-portfolio/PortfolioJobsInquirySection/PortfolioJobsInquirySectionProfile/types';

type JobsSelectWithCustomOptionProps = {
  options: SelectableOption[];
  label: string;
  attributeNameMain: string;
  attributeNameOther: string;
  placeholder?: string;
  mainValue?: string | null;
  otherValue?: string | null;
  isValid?: boolean;
  hint?: string;
};
type JobsSelectWithCustomOptionEmits = {
  (
    event: 'change',
    payload: {
      [key: string]: string | null;
    },
  ): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsSelectWithCustomOption',
  props: {
    options: null,
    label: null,
    attributeNameMain: null,
    attributeNameOther: null,
    placeholder: { default: '' },
    mainValue: { default: null },
    otherValue: { default: null },
    isValid: { type: Boolean, default: true },
    hint: { default: '' }
  },
  emits: ["change"],
  setup(__props: any, { emit }: { emit: ({
  (
    event: 'change',
    payload: {
      [key: string]: string | null;
    },
  ): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { options: SelectableOption[], label: string, attributeNameMain: string, attributeNameOther: string, placeholder: string, mainValue: string | null, otherValue: string | null, isValid: boolean, hint: string };




const OTHER_OPTION_VALUE = 'other';

const selectedMainValue = ref(props.mainValue || OTHER_OPTION_VALUE);
const selectedOtherValue = ref(props.otherValue || null);
const input = ref<HTMLInputElement | null>(null);

const optionsWithOther = computed(() => [
  ...props.options,
  {
    value: OTHER_OPTION_VALUE,
    label: 'Other',
  },
]);
const isOtherInputVisible = computed(
  () => selectedMainValue.value === OTHER_OPTION_VALUE || !!selectedOtherValue.value,
);

function handleChange(): void {
  emit('change', {
    [props.attributeNameMain]: selectedMainValue.value === OTHER_OPTION_VALUE ? null : selectedMainValue.value,
    [props.attributeNameOther]: selectedOtherValue.value,
  });
}

function handleChangeMainValue(value: string): void {
  if (value === OTHER_OPTION_VALUE) {
    nextTick(() => {
      input.value?.focus();
    });
  }

  selectedOtherValue.value = null;
  handleChange();
}

return { __sfc: true,props, emit, OTHER_OPTION_VALUE, selectedMainValue, selectedOtherValue, input, optionsWithOther, isOtherInputVisible, handleChange, handleChangeMainValue, BravadoSelectV3, BravadoTextInputV3 }
}

})